var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-customer loading-content-container" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-customer-basedata", {
                        attrs: {
                          "form-context":
                            _vm.initialFormContexts.customerBasedata,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-row",
                    [
                      _c("csp-desktop-customer-bankaccount", {
                        attrs: {
                          "form-context":
                            _vm.initialFormContexts.customerBankAccount,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-4" },
                    [
                      _c("csp-desktop-customer-insurance-liability", {
                        attrs: {
                          "form-context":
                            _vm.initialFormContexts.customerInsuranceLiability,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-4" },
                    [
                      _c("csp-desktop-customer-insurance-legal-expense", {
                        attrs: {
                          "form-context":
                            _vm.initialFormContexts
                              .customerInsuranceLegalExpense,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-4" },
                    [
                      _c("csp-desktop-customer-insurance-breakdown-cover", {
                        attrs: {
                          "form-context":
                            _vm.initialFormContexts
                              .customerInsuranceBreakdownCover,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }